import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

import { Deal, DealsService, UserService } from '../core';
import { catchError ,  map } from 'rxjs/operators';

@Injectable()
export class SubmitDealResolver implements Resolve<Deal> {
    constructor(
        private dealsService: DealsService,
        private router: Router,
        private userService: UserService
    ) { }

    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<any> {

        return this.dealsService.get(route.params['dealID'])
            .pipe(
                map(
                    deal => {
                        if (this.userService.getCurrentUser().userID === deal.link_author) {
                            return deal;
                        } else {
                            this.router.navigateByUrl('/');
                        }
                    }
                ),
                catchError((err) => this.router.navigateByUrl('/'))
            );
    }
}
